// extracted by mini-css-extract-plugin
module.exports = {"NavigationItem":"NavigationItem_NavigationItem__2iLBc","active":"NavigationItem_active__2h3hu"};